import React from 'react';
import ArtifactViewCodeDiffHeader from '~/artifact/components/ArtifactViewCodeDiffHeader';
import ArtifactViewCodeDiffDisplay from '~/artifact/components/ArtifactViewCodeDiffDisplay';
type ArtifactViewMainContentFixInfoHowToFixPackageManagerCocoaPodsProps = {
  component: object;
  range: object;
  safeVersion?: string;
  unsafeVersion?: object;
  transitive?: boolean;
};
const ArtifactViewMainContentFixInfoHowToFixPackageManagerCocoaPods: React.SFC<
  ArtifactViewMainContentFixInfoHowToFixPackageManagerCocoaPodsProps
> = props => {
  let component = props.component,
    range = props.range || {},
    safeVersion = props.safeVersion,
    unsafeVersion =
      props.unsafeVersion ||
      (range.versionRange && range.versionRange.indexOf('-') !== -1
        ? range.versionRange.split('-')[0]
        : ''),
    transitive = props.transitive == undefined ? false : props.transitive;
  if (!transitive) {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="Podfile" />
        <ArtifactViewCodeDiffDisplay
          type="delete"
          text={"pod '" + component.coordinate1 + "'," + " '" + unsafeVersion + "'"}
        />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={"pod '" + component.coordinate1 + "'," + " '" + safeVersion + "'"}
        />
      </div>
    );
  } else {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="Podfile" />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={"pod '" + component.coordinate1 + "'," + " '" + safeVersion + "'"}
        />
      </div>
    );
  }
};
export default ArtifactViewMainContentFixInfoHowToFixPackageManagerCocoaPods;
